import { AppThunk } from '../../types';
import {
  setCancelTitleSearchRequestsErrorAction,
  setCancelTitleSearchRequestsFetchStatusAction,
  setCreateTitleSearchRequestsErrorAction,
  setCreateTitleSearchRequestsFetchStatusAction,
  setRedVisionSearchAction,
  setRedVisionSearchErrorAction,
  setRedVisionSearchFetchStatusAction,
  setTitleSearchRequestsAction,
  setTitleSearchRequestsErrorAction,
  setTitleSearchRequestsFetchStatusAction,
} from './reducer';
import { createFetchedSuccess, createFetchedWithError, createFetchInProgress } from 'types/rest/IFetchStatus';
import { ITitleSearchRequestData } from '../../../types/order/title/ITitleSearchRequest';
import {
  cancelTitleSearchAsync,
  createTitleSearchAsync,
  getTitleSearchHistoryAsync,
  getRedVisionSearchAsync,
} from '../../../API/order/title/adminTitleSearchAPI';
import { IRedVisionSearchData } from '../../../types/order/title/IRedVisionSearch';
import { IOrderDetailsData } from '../../../ui-toolkit/orders/interfaces/IOrderDetailsData';

export const getTitleSearchRequest =
  (orderId: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setTitleSearchRequestsErrorAction(null));
      dispatch(setTitleSearchRequestsFetchStatusAction(createFetchInProgress()));
      const response: ITitleSearchRequestData[] = await getTitleSearchHistoryAsync(orderId);
      dispatch(setTitleSearchRequestsAction({ orderId, value: response }));
      dispatch(setTitleSearchRequestsFetchStatusAction(createFetchedSuccess()));
    } catch (e: any) {
      dispatch(setTitleSearchRequestsFetchStatusAction(createFetchedWithError()));
      dispatch(setTitleSearchRequestsErrorAction(e.message));
    }
  };

export const getRedVisionSearch =
  (order?: IOrderDetailsData): AppThunk =>
  async (dispatch) => {
    try {
      if (order?.transaction?.hasRedvisionTask === true) {
        dispatch(setRedVisionSearchErrorAction(null));
        dispatch(setRedVisionSearchFetchStatusAction(createFetchInProgress()));
        const response: IRedVisionSearchData = await getRedVisionSearchAsync(order?.transaction?.id ?? '');
        dispatch(setRedVisionSearchAction({ orderId: order?.transaction?.id ?? '', value: response }));
        dispatch(setRedVisionSearchFetchStatusAction(createFetchedSuccess()));
      }
    } catch (e: any) {
      if (e.response.status === 404) {
        dispatch(setRedVisionSearchFetchStatusAction(createFetchedSuccess()));
      } else {
        dispatch(setRedVisionSearchFetchStatusAction(createFetchedWithError()));
        dispatch(setRedVisionSearchErrorAction(e.message));
      }
    }
  };

export const createTitleSearch =
  (orderId: string): AppThunk =>
  async (dispatch, getState) => {
    const titleSearches = getState().order.titleSearchRequests.titleSearchRequest;
    try {
      dispatch(setCreateTitleSearchRequestsErrorAction(null));
      dispatch(setCreateTitleSearchRequestsFetchStatusAction(createFetchInProgress()));
      const response: ITitleSearchRequestData = await createTitleSearchAsync(orderId);
      dispatch(setTitleSearchRequestsAction({ orderId, value: [...titleSearches[orderId], response] }));
      dispatch(setCreateTitleSearchRequestsFetchStatusAction(createFetchedSuccess()));
    } catch (e: any) {
      dispatch(setCreateTitleSearchRequestsFetchStatusAction(createFetchedWithError()));
      dispatch(setCreateTitleSearchRequestsErrorAction(e.message));
    }
  };

export const cancelTitleSearch =
  (orderId: string, titleSearchRequestId: string): AppThunk =>
  async (dispatch, getState) => {
    const titleSearches = getState().order.titleSearchRequests.titleSearchRequest;
    try {
      dispatch(setCancelTitleSearchRequestsErrorAction(null));
      dispatch(setCancelTitleSearchRequestsFetchStatusAction(createFetchInProgress()));
      const response: ITitleSearchRequestData = await cancelTitleSearchAsync(titleSearchRequestId);
      const titleSearchIndex = titleSearches[orderId].findIndex(
        (search) => search.titleSearchId === titleSearchRequestId
      );
      if (titleSearchIndex) {
        titleSearches[orderId][titleSearchIndex] = response;
        dispatch(setTitleSearchRequestsAction({ orderId, value: titleSearches[orderId] }));
      }
      dispatch(setCancelTitleSearchRequestsFetchStatusAction(createFetchedSuccess()));
    } catch (e: any) {
      dispatch(setCancelTitleSearchRequestsFetchStatusAction(createFetchedWithError()));
      dispatch(setCancelTitleSearchRequestsErrorAction(e.message));
    }
  };
